/*                                                                  */
export function convertStringToFunction<T extends Function>(
  functionName: string,
  /*                                                          */
  context: Record<string, any>,
): T {
  const namespaces = functionName.split(".");
  const func = namespaces.pop() as string;

  let part = context;
  for (let i = 0, len = namespaces.length; i < len; i += 1) {
    part = part[namespaces[i]];
  }

  return part[func];
}
